export default __webpack_public_path__ + "static/media/LENS_CULINARIS_GDM_1.cbd87088.jpg";